import { useState, useEffect } from 'react'

const useRelatedBreeds = (id) => {
  const [relatedBreeds, setRelatedBreeds] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const getRelatedBreeds = async () => {
      setIsLoading(true)
      try {
        const request = await fetch(`/api/related-breeds/${id}`)
        const data = await request.json()
        setRelatedBreeds(data.relatedBreeds)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    getRelatedBreeds()
  }, [id])

  return { relatedBreeds, isLoading }
}

export default useRelatedBreeds
